/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const roadmapItems = [
    { title: 'Audit Trails', desc: 'Full compliance history of every data change.', icon: 'bi-clock-history' },
    { title: 'Social Login', desc: 'SSO with Google, Microsoft, and LinkedIn.', icon: 'bi-google' },
    { title: 'Agentic AI', desc: 'Autonomous agents to handle complex workflows.', icon: 'bi-robot' },
    { title: 'Marketplace', desc: 'Publish Applications for other organizations to use. Make Additional Revenue.', icon: 'bi-shop' }
];

function RoadmapSection() {
    const { theme } = useTheme();

    return (
        <section id="roadmap" className="py-5" style={{ background: '#f8f9fa' }}>
            <div className="container py-5 text-center">
                <h2 className="fw-bold display-4 mb-3" style={{ color: theme.primary }}>
                    Product Roadmap
                </h2>
                <p className="lead text-muted mb-5">Innovating for the Future of Work.</p>

                <div className="row justify-content-center g-4">
                    {roadmapItems.map((item, index) => (
                        <div className="col-md-3" key={index}>
                            <div
                                className="p-4 bg-white rounded-4 shadow-sm h-100"
                                style={{ borderTop: `4px solid ${theme.secondary}` }}
                            >
                                <div className="mb-3 text-secondary">
                                    <i className={`${item.icon} display-5`}></i>
                                </div>
                                <h5 className="fw-bold mb-2">{item.title}</h5>
                                <p className="text-muted small mb-0">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default RoadmapSection;
